import { useMemo, useState } from "react";
import { theme } from "../../../theme";
import JobStatusChangeLogs from "./JobStatusChangeLogs";
import RescheduleDetails from "./RescheduleDetails";
import ExpressJobDetails from "./ExpressJobDetails";
import ApproveForAnotherDate from "./ApproveForAnotherDate";

const JobStatus = ({
    job_id,
    job_status,
    job_approve_for_another_date,
    job_is_reschedule_job,
    job_is_express_job,
    job_is_have_customer_signature,
    job_is_remedial_job
}) => {
    const [showJobStatusChangeLogs, setShowJobStatusChangeLogs] = useState(false);
    const handleShowJobStatusChangeLogs = () => setShowJobStatusChangeLogs(true);
    const handleCloseJobStatusChangeLogs = () => setShowJobStatusChangeLogs(false);

    const [approveForAnotherDateJobId, setApproveForAnotherDateJobId] = useState(null);
    const [showApproveForAnotherDate, setShowApproveForAnotherDate] = useState(false);
    const handleShowApproveForAnotherDate = (another_date_job_id) => {
        setApproveForAnotherDateJobId(another_date_job_id);
        setShowApproveForAnotherDate(true);
    }
    const handleCloseApproveForAnotherDate = () => setShowApproveForAnotherDate(false);

    const [showRescheduleDetails, setShowRescheduleDetails] = useState(false);
    const handleShowRescheduleDetails = () => setShowRescheduleDetails(true);
    const handleCloseRescheduleDetails = () => setShowRescheduleDetails(false);

    const [showExpressJobDetails, setShowExpressJobDetails] = useState(false);
    const handleShowExpressJobDetails = () => setShowExpressJobDetails(true);
    const handleCloseExpressJobDetails = () => setShowExpressJobDetails(false);

    const jobStatus = useMemo(() => ([
        {
            title: "Job status",
            description: job_status?.job_status_name,
            icon: job_status?.job_status_icon,
            value: job_status?.job_status_id,
            color: job_status?.job_status_color,
            action: () => handleShowJobStatusChangeLogs(),
            isDisabledDetailsBtn: false
        },
        {
            title: "Approve for another date",
            description: "Confirm the job and allow it to be scheduled for a new date based on availability.",
            icon: "date_range",
            value: job_approve_for_another_date?.approve_for_another_date_job_id,
            color: job_approve_for_another_date?.job_is_approve_for_another_date_job === 1 ? theme.main_code : null,
            action: () => handleShowApproveForAnotherDate(job_approve_for_another_date?.approve_for_another_date_job_id),
            isDisabledDetailsBtn: job_approve_for_another_date?.job_is_approve_for_another_date_job !== 1
        },
        {
            title: "Reschedule",
            description: "Shows if the original appointment date or time was changed",
            icon: "schedule_send",
            value: job_is_reschedule_job,
            color: job_is_reschedule_job === 1 ? theme.main_code : null,
            action: () => handleShowRescheduleDetails(),
            isDisabledDetailsBtn: job_is_reschedule_job !== 1
        },
        {
            title: "Express job",
            description: "Marks jobs that require priority or urgent service handling",
            icon: "speed",
            value: job_is_express_job,
            color: job_is_express_job === 1 ? theme.main_code : null,
            action: () => handleShowExpressJobDetails(),
            isDisabledDetailsBtn: job_is_express_job !== 1
        },
        // {
        //     title: "Customer signature",
        //     description: "Confirms whether the customer provided a signature after job completion",
        //     icon: "edit",
        //     value: job_is_have_customer_signature,
        //     color: job_is_have_customer_signature === 1 ? theme.main_code : null,
        //     action: () => handleShowJobStatusChangeLogs(),
        //     isDisabledDetailsBtn: job_is_have_customer_signature !== 1
        // },
        // {
        //     title: "Remedial job",
        //     description: "Identifies jobs created to fix or correct previous work",
        //     icon: "business_center",
        //     value: job_is_remedial_job,
        //     color: job_is_remedial_job === 1 ? theme.main_code : null,
        //     action: () => handleShowJobStatusChangeLogs(),
        //     isDisabledDetailsBtn: job_is_remedial_job !== 1
        // }
    ]), [job_status?.job_status_name, job_status?.job_status_icon, job_status?.job_status_id, job_status?.job_status_color, job_approve_for_another_date?.approve_for_another_date_job_id, job_approve_for_another_date?.job_is_approve_for_another_date_job, job_is_reschedule_job, job_is_express_job]);

    return (
        <>
            {jobStatus.map((item, index) => (
                <div className="col-lg-3 col-sm-6" key={index}>
                    <div className="card h-100">
                        <div className="card-body">
                            <div className="d-flex mb-4">
                                <p className="mb-0">Details</p>
                                <div className="form-check form-switch ms-auto">
                                    <button 
                                        type="button" 
                                        className="btn btn-icon-only btn-rounded btn-outline-secondary mb-0 ms-2 btn-sm d-flex align-items-center justify-content-center" 
                                        onClick={item.action}
                                        disabled={item.isDisabledDetailsBtn}
                                    >
                                        <i className="material-icons text-sm">priority_high</i>
                                    </button>
                                </div>
                            </div>
                            <i className="material-icons opacity-10" style={{ fontSize: "60px", color: item.color }}>{item?.icon}</i>
                            <p className="mt-1 mb-0 font-weight-bold">{item?.title}</p>
                            <span className="text-xs">{item?.description}</span>
                        </div>
                    </div>
                </div>
            ))}

            <JobStatusChangeLogs
                job_id={job_id}
                show={showJobStatusChangeLogs}
                handleClose={handleCloseJobStatusChangeLogs}
            />

            <ApproveForAnotherDate
                approve_for_another_date_job_id={approveForAnotherDateJobId}
                show={showApproveForAnotherDate}
                handleClose={handleCloseApproveForAnotherDate}
            />

            <RescheduleDetails
                job_id={job_id}
                show={showRescheduleDetails}
                handleClose={handleCloseRescheduleDetails}
            />

            <ExpressJobDetails 
                job_id={job_id}
                show={showExpressJobDetails}
                handleClose={handleCloseExpressJobDetails}
            />
        </>
    );
};

export default JobStatus;